export const TRIP_STATUS_PLANNED = "planejado";
export const TRIP_STATUS_IN_PROGRESS = "em rota";
export const TRIP_STATUS_TYPES = [TRIP_STATUS_PLANNED, TRIP_STATUS_IN_PROGRESS] as const;
export type tripStatus = typeof TRIP_STATUS_TYPES[number];
//export type clientType = typeof TRIP_CLIENT_TYPES[number];
